export default __webpack_public_path__ + "static/coinrequest-e434dce4a63d2aa45d07faa44afdddc7.jpg";